module.exports = __webpack_public_path__ + "img/shape.a7f61ce4.png";